// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadiusUprightOutlinedSvg from "@ant-design/icons-svg/es/asn/RadiusUprightOutlined";
import AntdIcon from '../components/AntdIcon';

var RadiusUprightOutlined = function RadiusUprightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadiusUprightOutlinedSvg
  }));
};

RadiusUprightOutlined.displayName = 'RadiusUprightOutlined';
export default React.forwardRef(RadiusUprightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/RadiusUprightOutlined.js
// module id = 1671
// module chunks = 0